import _ from "lodash";
import tailwindConfig from "../../../../tailwind.config";
import { Series } from "./Chart.types";

const colors: { default: string; negative: string; highlighted: string }[] =
    Object.values(tailwindConfig.theme.extend.colors.chart);

const hydrateSeriesStyles = (series: Series): Series => {
    if (!series) return;

    return series.map((s, i) => {
        if (s.type === "line") {
            const { default: color } = colors[i === 0 ? 1 : i + 1];
            return _.merge(
                {
                    stroke: color || "#000",
                    marker: {
                        fill: color || "#000",
                        size: 9,
                    },
                    cursor: "pointer",
                },
                s,
            );
        }

        if (s.type === "bar") {
            const { default: color, negative, highlighted } = colors[i];
            return _.merge(
                {
                    fill: color || "#000",
                    cornerRadius: 6,
                    cursor: "pointer",
                    shadow: {
                        enabled: false,
                    },
                    stroke: color || "#000",
                    strokeWidth: 1.5,
                    strokeOpacity: 0,
                    itemStyler: (params) => {
                        let fill = color;
                        if (params.yValue < 0) {
                            fill = negative;
                        }
                        if (params.highlighted) {
                            fill = highlighted;
                        }
                        return {
                            fill,
                        };
                    },
                },
                s,
            );
        }

        return s;
    });
};

export default hydrateSeriesStyles;
